/*###########################################################################
// Tabs
//#########################################################################*/

import { throttle } from "../utilities/_throttleDebounce"
import { scrollTo } from "../utilities/_scrollTo"

export default function tabs() {
	return {
		activeTab: 1,

		breakpoints: {
			desktop: 1024
		},

		init() {
			const self = this

			setTimeout(function() {
				if (self.$el.hasAttribute('data-tab-pref')) {
					const prefTab = self.$el.querySelector('.tabs__nav__item[data-tab-title="' + self.$el.getAttribute('data-tab-pref') + '"]')

					if (prefTab !== null) {
						const prefTabIndex = parseInt(prefTab.getAttribute('data-tab'))
						self.setActiveTab(prefTabIndex)
					} else {
						self.setActiveFirstTab()
					}
 				} else {
					self.setActiveFirstTab()
				}

				window.addEventListener('resize', throttle(function() {
					self.updateTabNavItem(self.activeTab)
				}, 500))

				setTimeout(function() {
					self.$el.style.opacity = '1'
				}, 100)
			}, 250)
		},

		setActiveTab(tabIndex) {
			this.activeTab = tabIndex

			this.updateTabNavItem(tabIndex)

			if (window.innerWidth < this.breakpoints.desktop) {
				const offsetAmount = document.querySelector('.header')?.clientHeight || 0
				scrollTo(this.$el, -offsetAmount)
			}
		},

		setActiveFirstTab(tabIndex) {
			const firstTab = this.$el.querySelector('.tabs__nav__item')
			if (firstTab === null) return

			const firstTabIndex = parseInt(firstTab.getAttribute('data-tab'))
			this.activeTab = firstTabIndex
			this.updateTabNavItem(firstTabIndex)

			if (window.innerWidth < this.breakpoints.desktop) {
				const offsetAmount = document.querySelector('.header')?.clientHeight || 0
				scrollTo(this.$el, -offsetAmount)
			}
		},

		handleSelectChange(event) {
			if (event.target.classList.contains('input')) {
				this.activeTab = parseInt(event.target.options[event.target.selectedIndex].value)

				this.updateTabNavItem(this.activeTab)

				if (window.innerWidth < this.breakpoints.desktop) {
					const offsetAmount = document.querySelector('.header')?.clientHeight || 0
					scrollTo(this.$el, -offsetAmount)
				}
			}
		},

		updateTabNavItem(tabIndex) {
			const activeNavItem = this.$root.querySelector('.tabs__nav__item[data-tab="' + tabIndex + '"]')

			if (activeNavItem !== null) {
				const rect = activeNavItem.getBoundingClientRect();

				if (this.$refs.tabsNav !== undefined) {
					const containerRect = this.$refs.tabsNav.getBoundingClientRect();

					this.$refs.tabsNavBg.style.left = rect.left - containerRect.left + 'px';
					this.$refs.tabsNavBg.style.top = rect.top - containerRect.top + 'px';
					this.$refs.tabsNavBg.style.width = rect.width + 'px';
				}
			}
		}
	}
}
